<template>
  <BaseScreen v-bind="screen">
    <Hashtag
      v-if="hashtag"
      v-bind="hashtag"
      class="screen__hashtag screen__stretch"
      @close="stopSelfieAction"
    />
    <div v-else class="screen__row screen__stretch screen__row_column">
      <div class="screen__col">
        <BaseText
          v-if="description"
          v-bind="description"
        />
      </div>
      <div class="screen__col screen__col_stretch screen__gap">
        <BaseMenu
          :items="menuItems"
        />
      </div>
    </div>
  </BaseScreen>
</template>

<script>
import screenMixin from '@/mixins/screen';
import BaseMenu from '@/components/BaseMenu.vue';
import BaseText from '@/components/BaseText.vue';
import Hashtag from '@/components/Hashtag.vue';

export const HASHTAGS = Object.freeze({
  ONE: 'hashtag_1',
  TWO: 'hashtag_2',
  THREE: 'hashtag_3',
  FOUR: 'hashtag_4',
});

export default {
  name: 'SelfieScreen',
  mixins: [screenMixin],
  components: {
    BaseMenu,
    BaseText,
    Hashtag,
  },
  data() {
    return {
      activeHashtag: null,
    };
  },
  computed: {
    titleText() {
      return this.$t('selfie.title');
    },
    screenCase() {
      if (this.activeHashtag) {
        return 'STEP_HASHTAG';
      }
      return 'STEP_SELFIE';
    },
    isPatternBackground() {
      return Boolean(this.activeHashtag);
    },
    isHeaderHidden() {
      return this.isPatternBackground;
    },
    isFooterHidden() {
      return this.isPatternBackground;
    },
    hashtag() {
      if (!this.activeHashtag) return null;
      return {
        title: {
          text: this.activeHashtag,
          isUp: true,
        },
        timerDuration: 60,
      };
    },
    description() {
      return {
        text: this.$t('selfie.description'),
        size: 'xl',
        isCenter: true,
      };
    },
    menuItems() {
      return Object.values(HASHTAGS).map((hashtag) => ({
        label: {
          text: this.$t(`selfie.${hashtag}`),
          size: 'm',
        },
        action: () => this.startSelfieAction(hashtag),
      }));
    },
  },
  created() {
    this.initActions([
      // ['ACTION_ABORT_SELFIE', this.stopSelfieAction],
      ['ACTION_HASHTAG_ONE', this.pickOneHashtag],
      ['ACTION_HASHTAG_TWO', this.pickTwoHashtag],
      ['ACTION_HASHTAG_THREE', this.pickThreeHashtag],
      ['ACTION_HASHTAG_FOUR', this.pickFourHashtag],
    ]);
  },
  methods: {
    pickOneHashtag() {
      this.startSelfieAction(HASHTAGS.ONE);
    },
    pickTwoHashtag() {
      this.startSelfieAction(HASHTAGS.TWO);
    },
    pickThreeHashtag() {
      this.startSelfieAction(HASHTAGS.THREE);
    },
    pickFourHashtag() {
      this.startSelfieAction(HASHTAGS.FOUR);
    },
    startSelfieAction(hashtag) {
      this.activeHashtag = this.$t(`selfie.${hashtag}`);
      this.$robot.dialogService.muteOn();
    },
    stopSelfieAction() {
      this.activeHashtag = null;
      this.$robot.dialogService.muteOff();
    },
  },
};
</script>
